import axios from '../plugins/axios';

export default {
  loadRecentMenuCount() {
    const url = process.env.VUE_APP_HIWORKS_COUNT_API + `/menu`;
    const options = {};
    return axios.get(url, options);
  },
  loadNotificationCount() {
    const url = process.env.VUE_APP_HIWORKS_COUNT_API + `/alarm`;
    const options = {
      timeout: 60_000,
      headers: {
        'x-skip-session-refresh': 1,
      },
      withCredentials: true,
    };
    return axios.get(url, options);
  },
  loadNotificationCountRefresh() {
    const url = process.env.VUE_APP_HIWORKS_COUNT_API + `/alarm/refresh`;
    const options = {};
    return axios.get(url, options);
  },
};
